fragment SocialFeatureFragment on socialFeature_Entry {
  typeHandle
  heading
}
